import { handleRest } from '../../h2Api'
import * as assignmentActions from '../../actions/planning/assignments'

const initialState = {
  currentPage: -1,
  data: handleRest(null),
  modifiedTask: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case assignmentActions.ASSIGNMENT_TASK_APPEND_LIST: {
      //console.log("FOUND", action.newTask, state.data.result.tasks, action.taskId)

      const tasks = [
        ...state.data.result.tasks.filter(t => t.id !== action.taskId),
        action.newTask
      ].sort((a, b) => {
        return a.sortPos - b.sortPos
      })
      const totalTasks = tasks.length
      const completedTasks = tasks.filter(t => t.status.id == 3).length
      const pct = 100 * (completedTasks / totalTasks)
      const adjustedPct = Math.min(state.data.result.completed ? 100 : 99, pct)
      // console.log(adjustedPct, state.data.result, completedTasks, pct)
      const newState = {
        ...state,
        data: {
          ...state.data,
          result: {
            ...state.data.result,
            percentComplete: adjustedPct,
            tasks
          }
        }
      }

      console.log(newState)

      return newState
    }
    case assignmentActions.ASSIGNMENT_TASK_SAVE:
      console.log('ST', state, action)

      return {
        ...state,
        modifiedTask: handleRest(action)
      }

    case assignmentActions.ASSIGNMENT_LOADED:
      console.log(action, state.data.result)

      return {
        ...state,
        data: handleRest(action)
      }
    case assignmentActions.ASSIGNMENT_MOVE_TO:
      return {
        ...state,
        currentPage: action.page
      }
    case assignmentActions.UPDATE_STORED:
      return {
        ...state,
        data: {
          ...state.data,
          result: {
            ...state.data.result,
            ...action.data
          }
        }
      }
    case assignmentActions.UPDATE_STORED_TASK:
      return {
        ...state,
        data: {
          ...state.data,
          result: {
            ...state.data.result,
            tasks: [
              ...state.data.result.tasks.filter(t => t.id !== action.data.id),
              action.data
            ].sort((a, b) => a.sortBy - b.sortBy)
          }
        }
      }
    default:
      return state
  }
}

export default reducers
